var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"grid grid--multiline"},_vm._l((_vm.facts),function(fact){return _c('div',{key:fact.title,staticClass:"grid__item md-w-1/2"},[_c('fact',{attrs:{"fact":fact}})],1)}))])}
var staticRenderFns = []

export { render, staticRenderFns }